import { Modal, Box } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const defaultForm = {
  gender: "male",
  role: "Host",
  callType: "Audio",
  verificationStatus: "Normal",
  conversionRate: "",
  isActive: false,
};

const getDefaultForm = (type) => ({
  gender: "male",
  role: "Host",
  callType: "Audio",
  category: null,
  verificationStatus: "Normal",
  conversionRate: "",
  isActive: false,
});

const GangCoinConversionModal = ({
  open,
  type,
  onClose,
  initialData = null,
  onRefresh,
  mastiCategories,
}) => {
  const isEditing = Boolean(initialData);

  const [form, setForm] = useState(getDefaultForm(type));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      if (initialData) {
        setForm({
          gender: initialData.gender,
          callType: initialData?.callType,
          role: initialData.role,
          category: initialData?.category?._id || initialData?.category,
          verificationStatus: initialData.verificationStatus,
          conversionRate: initialData.conversionRate,
          isActive: initialData.isActive,
        });
      } else {
        setForm(getDefaultForm(type));
      }
    }
  }, [open, initialData]);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    let target = "";

    if (type === "call-conversion") {
      target = "private-call-conversion";
    } else if (type === "gang-conversion") {
      target = "gang-coin-conversion";
    } else if (type === "masti-conversion") {
      target = "masti-coin-conversion";
    }
    let endPoint = isEditing ? `/update/${initialData._id}` : "/create";

    let config = {
      method: isEditing ? "put" : "post",
      url: `${process.env.REACT_APP_API_URL}/${target}/${endPoint}`,
      data: form,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of handle submit: ", response.data);
        toast.success(response.data.message);
        onClose();
        onRefresh();
      })
      .catch((error) => {
        console.log("Error in handleSubmit: ", error);
        toast.error(
          error?.response?.data?.message ||
            "Something went wrong. Please try again."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 420,
          bgcolor: "white",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <h2 className="mb-4 text-lg font-semibold">
          {isEditing
            ? `Edit ${
                type === "call-conversion"
                  ? "Call"
                  : type === "gang-conversion"
                  ? "Gang"
                  : "Masti"
              } Coin Conversion`
            : `Add ${
                type === "call-conversion"
                  ? "Call"
                  : type === "gang-conversion"
                  ? "Gang"
                  : "Masti"
              } Coin Conversion`}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Gender */}
          <div>
            <label className="mb-1 block text-sm">Gender</label>
            <select
              className="w-full rounded-md border px-3 py-2"
              value={form.gender}
              onChange={(e) => handleChange("gender", e.target.value)}
            >
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

          {type === "masti-conversion" && (
            <div>
              <label className="mb-1 block text-sm">Masti Category</label>
              <select
                className="w-full rounded-md border px-3 py-2"
                value={form.category}
                onChange={(e) => handleChange("category", e.target.value)}
              >
                <option value="">Select Masti category</option>
                {mastiCategories?.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Role */}
          {type === "call-conversion" ? (
            <div>
              <label className="mb-1 block text-sm">Call Type</label>
              <select
                className="w-full rounded-md border px-3 py-2"
                value={form.callType}
                onChange={(e) => handleChange("callType", e.target.value)}
              >
                <option value="Audio">Audio</option>
                <option value="Video">Video</option>
                <option value="Gift">Gift</option>
              </select>
            </div>
          ) : (
            <div>
              <label className="mb-1 block text-sm">Role</label>
              <select
                className="w-full rounded-md border px-3 py-2"
                value={form.role}
                onChange={(e) => handleChange("role", e.target.value)}
              >
                <option value="Host">Host</option>

                {(type === "gang-conversion" ||
                  type === "masti-conversion") && (
                  <option value="Co-Host">Co-Host</option>
                )}

                {type === "masti-conversion" && (
                  <option value="Member">Member</option>
                )}
              </select>
            </div>
          )}

          {/* Verification */}
          <div>
            <label className="mb-1 block text-sm">Verification Status</label>
            <select
              className="w-full rounded-md border px-3 py-2"
              value={form.verificationStatus}
              onChange={(e) =>
                handleChange("verificationStatus", e.target.value)
              }
            >
              <option value="Normal">Normal</option>
              <option value="Verified">Verified</option>
            </select>
          </div>

          {/* Conversion Rate */}
          <div>
            <label className="mb-1 block text-sm">Conversion Rate</label>
            <input
              type="number"
              step="0.01"
              required
              className="w-full rounded-md border px-3 py-2"
              value={form.conversionRate}
              onChange={(e) => handleChange("conversionRate", e.target.value)}
            />
          </div>

          {/* Active */}
          <div className="flex items-center">
            <input
              type="checkbox"
              id="isActive"
              checked={form.isActive}
              onChange={(e) => handleChange("isActive", e.target.checked)}
              className="mr-2"
            />

            <label htmlFor="isActive">Active Conversion Rate</label>
          </div>
          {form.isActive && (
            <span className="text-sm text-red-700">
              ( This will deactivate the active one with same config)
            </span>
          )}

          {/* Actions */}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border px-4 py-2"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="rounded-md bg-[#c51369] px-4 py-2 text-white"
            >
              {isEditing ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default GangCoinConversionModal;
